import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ProductivityIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 16.312 18.3"
    >
      <g id="Groupe_2513" data-name="Groupe 2513" transform="translate(-715.661 -312.001)">
        <path
          id="Tracé_83"
          data-name="Tracé 83"
          d="M134.924,137.376v8.553L142.3,149.9v-8.035Z"
          transform="translate(581.488 179.65)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Tracé_84"
          data-name="Tracé 84"
          d="M149.735,137.376v8.269l-7.4,4.248v-7.962Z"
          transform="translate(581.488 179.65)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Tracé_85"
          data-name="Tracé 85"
          d="M134.924,137.376l7.376,4.486,7.436-4.486-7.541-4.276Z"
          transform="translate(581.488 179.65)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
